import React, { ReactElement } from 'react';
import { Tooltip } from '@mui/material';

export function SnappingSettingsTooltip(props: { title: string; children: ReactElement }) {
  return (
    <Tooltip disableInteractive placement="left" title={props.title}>
      <span>{props.children}</span>
    </Tooltip>
  );
}
